import stripHtml from '@shared/utils/stripHtml'

/**
 * Counts the length of rich text (HTML) as plain text, in the same way the
 * Froala editor does: parse HTML in a DOM and use textContent length.
 * Use this in both the editor (RichTextEditorField) and the schema
 * (createRichTextAreaSchema) so validation and UI always match.
 * In environments without DOM (e.g. Node tests), falls back to stripHtml length.
 */
export function getRichTextLength(html: string): number {
  if (typeof document !== 'undefined') {
    const div = document.createElement('div')
    div.innerHTML = html
    return (div.textContent ?? '').length
  }
  return stripHtml(html).length
}
